export const FORM_VIEW = Object.freeze({
  LOGIN: "login",
  REQUIRE_SIGNUP: "requireSignup",
  REGISTER: "register"
});

export const EMAIL_VALIDATION_PATTERN = /^([a-z0-9_+-][a-z0-9_+-.!#$%&=^`{|}~?/]*)@([a-z0-9-]+(\.[a-z0-9-]+)+)$/;
export const EMAIL_MAX_LENGTH = 128;
export const EMAIL_DOMAIN_CORRECTION_MAP = {
  "gamil.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gmaill.com": "gmail.com",
  "gnail.com": "gmail.com",
  "gmal.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.cm": "gmail.com",
  "gmil.com": "gmail.com",
  "gimal.com": "gmail.com",
  "yaho.com": "yahoo.com",
  "yhoo.com": "yahoo.com",
  "yaoo.com": "yahoo.com",
  "yahooo.com": "yahoo.com",
  "yahoo.con": "yahoo.com",
  "yahoo.co": "yahoo.com",
  "hotmial.com": "hotmail.com",
  "hotmai.com": "hotmail.com",
  "hotmal.com": "hotmail.com",
  "hitmail.com": "hotmail.com",
  "hormail.com": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "hotmil.com": "hotmail.com",
  "outlok.com": "outlook.com",
  "outlouk.com": "outlook.com",
  "outlook.con": "outlook.com",
  "icould.com": "icloud.com",
  "icloud.co": "icloud.com",
  "iclud.com": "icloud.com",
  "icloud.con": "icloud.com",
  "live.con": "live.com",
  "liev.com": "live.com",
  "liv.com": "live.com"
};

export const USERNAME_MAX_LENGTH = 20;
